import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import mobileAppsHero from "../assets/Hero/mobile-hero.jpg"; // Replace with your hero image
import mobileAppsImage from "../assets/Hero/mobile.webp"; // Replace with your mobile apps image
import "../assets/css/mobileApplicationsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const mobileAppsData = {
  hero: {
    title: "Mobile Applications",
    subtitle: "Empowering Your Business with Innovative Mobile Solutions",
  },
  introduction: {
    heading: "Why Mobile Applications Matter",
    paragraphs: [
      "Mobile applications are essential for modern businesses, enabling seamless customer engagement, improved productivity, and enhanced user experiences.",
      "Our mobile application solutions are designed to deliver high performance, intuitive interfaces, and seamless integration with your business workflows.",
    ],
  },
  cta: {
    heading: "Ready to Build Your Mobile Application?",
    text: "Contact us today to learn more about our Mobile Application Solutions and how we can help your business thrive.",
  },
};

export const MobileApplicationsPage = ({ data }) => {
  const mobileAppsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = mobileAppsRef.current.querySelectorAll(".mobile-apps-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: mobileAppsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="mobile-apps-page" ref={mobileAppsRef}>
      {/* Hero Section */}
      <div
        className="mobile-apps-hero-section"
        style={{ backgroundImage: `url(${mobileAppsHero})` }}
      >
        <h1 className="mobile-apps-animate">{mobileAppsData.hero.title}</h1>
        <p className="mobile-apps-animate">{mobileAppsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container mobile-apps-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="mobile-apps-animate">{mobileAppsData.introduction.heading}</h2>
            {mobileAppsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="mobile-apps-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 mobile-apps-image-container">
            <img
              src={mobileAppsImage}
              className="img-fluid mobile-apps-animate"
              alt="Mobile Applications"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container mobile-apps-cta">
        <h2 className="mobile-apps-animate">{mobileAppsData.cta.heading}</h2>
        <p className="mobile-apps-animate">{mobileAppsData.cta.text}</p>
        <button
          className="btn btn-primary mobile-apps-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};